import * as firebase from 'firebase';
const ga = global.ga;

/**
 * Initializes the Google Analytics tracker to track pageviews and exceptions
 * @param {history} history history routing object
 */
const initTracker = (history) => {
  if (global._trackerInitialized) {
    return;
  }

  /**
   * Set the userId for Google Analytics
   */
  function setUserId() {
    if (firebase.auth().currentUser) {
      const { uid, s6client, displayName } = firebase.auth().currentUser;
      ga('set', 'userId', uid);
    
      // Some dimensions to help identify the user in analytics
      if (s6client) {
        ga('set', 'dimension1', s6client);
      }
      if (firebase.auth().currentUser.displayName) {
        ga('set', 'dimension2', displayName);
      }
    }
  }

  /**
   * Track page views
   */
  function trackPageview() {
    setUserId();
    // Set the correct path for this one-page app on every history navigation
    ga('set', 'page', history.location.pathname + history.location.search);
    ga('send', 'pageview');
  }

  function trackExceptions() {
    if (typeof window.onerror === "object") {
      window.onerror = function (err, url, line) {
        ga('send', 'exception', {
          'exDescription': line + " " + err
        });
      };
    }
  }

  // Prepare for tracking global exceptions
  trackExceptions();

  // Track initial view
  trackPageview();

  // Track successive views
  history.listen((location, action) => {
    // If back/forward navigation, don't register a page view
    if (action === 'POP') {
      return;
    }
    trackPageview();
  });

  global._trackerInitialized = true;
}
export default initTracker;



// WEBPACK FOOTER //
// ./src/util/tracker.js